import React from "react"
import { StaticQuery, graphql } from "gatsby"

import styles from "./projects.module.scss"

export const Projects = () => (
  <StaticQuery
    query={graphql`
      {
        graphCMSData {
          projects {
            id
            name
            url
            description
            logo {
              url
            }
          }
        }
      }
    `}
    render={(data) => (
      <main>
        <article>
          <div>
            <div>
              <p>
                Here is a list of some of the projects I'm working on aside from
                my day job (mostly open source stuff).
              </p>

              {data.graphCMSData.projects.map((project) => (
                <div className={styles.projectWrapper} key={project.id}>
                  <a href={project.url} target="_blank" rel="noreferrer">
                    <img src={project.logo.url} alt={project.name} />
                    <h4>{project.name}</h4>
                  </a>
                  <p>{project.description}</p>
                  <hr />
                </div>
              ))}
            </div>
          </div>
        </article>
      </main>
    )}
  />
)
